<template>
  <div class="lock">
    <div class="pin-info lock-input">
      <h1 class="page-title">
        {{
          correctPin.length > 0
            ? $t("pages.login.confirmPin")
            : $t("pages.login.createPin")
        }}
      </h1>
    </div>
    <div class="pin-display">
      <div class="confirmation-dots">
        <svg>
          <g>
            <circle class="pin-circle" cx="10" cy="10" r="8" />
            <circle class="pin-circle" cx="50" cy="10" r="8" />
            <circle class="pin-circle" cx="90" cy="10" r="8" />
            <circle class="pin-circle" cx="130" cy="10" r="8" />
          </g>
        </svg>
      </div>
      <div class="lock-input keypad">
        <div
          class="keypad--button cs0"
          v-for="num of [1, 2, 3, 4, 5, 6, 7, 8, 9]"
          :key="num"
          :data-value="num"
        >
          {{ num }}
        </div>
        <div class="keypad--button keyboard--button__back-arrow">
          <i class="fhr fhr-delete cs0"></i>
        </div>
        <div class="keypad--button cs0" data-value="0">0</div>
        <div class="keypad--button keyboard--button__x cs0">
          <div class="fhr fhr-trash"></div>
        </div>
      </div>
      <!-- <div id="biometricsButton" class="lock-input" @click="loginWithBiometrics">
        {{ $t("pages.login.useFaceId") }}
      </div> -->
      <div id="kidsModeButton" class="lock-input" onclick="ChildSelectorModal.open()">
        {{ $t("pages.kids.kidsMode") }}
      </div>
    </div>
    <v-style>.bouncefix{display: none;}</v-style>
  </div>
</template>

<script>
import * as Parse from "parse";
import * as nativeLink from "../utilities/nativeLink";
export default {
  name: "LockScreen",
  data() {
    return {
      pinArray: [],
      disableInput: false,
      correctPin: "",
    };
  },
  async mounted() {
    this.correctPin = await Parse.User.current().get("pin");
    this.bindPinToDisplay();
    function errorShake() {
      return Promise.resolve();
    }
    window.onkeydown = function (e) {
      if (VueInstance.locked) {
        $(`[data-value="${e.key}"]`).click();
      }
    };
    $(".keyboard--button__back-arrow").addEventListener("click", () => {
      if (this.disableInput) return;
      this.pinArray.pop();
      this.bindPinToDisplay();
    });

    $(".keyboard--button__x").addEventListener("click", () => {
      if (this.disableInput) return;
      this.pinArray = [];
      this.bindPinToDisplay();
    });

    this.initKeypad();

    if (!window.hasMountedHome) {
      this.pinArray = [];
      this.$root.$data.locked = true;
      this.disableInput = false;
    }
    this.bindPinToDisplay();
  },
  methods: {
    async evaluatePin() {
      const enteredPin = String(this.pinArray.join(""));
      if (this.correctPin == null || this.correctPin == "") {
        await Parse.User.current().set("pin", enteredPin);
        await Parse.User.current().save();
        this.openLock();
      } else if (enteredPin == this.correctPin || this.correctPin == "") {
        this.disableInput = true;
        setTimeout(() => {
          this.bindPinToDisplay("success");
          setTimeout(() => {
            this.openLock();
          }, 500);
        }, 250);
      } else {
        this.disableInput = true;
        setTimeout(() => {
          this.bindPinToDisplay("error");
          setTimeout(() => {
            this.pinArray = [];
            this.bindPinToDisplay();
            this.disableInput = false;
          }, 350);
        }, 250);
      }
    },
    initKeypad() {
      $$(".keypad--button[data-value]").forEach((el) => {
        el.addEventListener("click", (evt) => {
          if (this.disableInput) return;
          if (this.pinArray.length < 4) {
            this.pinArray.push(evt.target.attributes["data-value"].value);
            this.bindPinToDisplay();
            if (this.pinArray.length === 4) this.evaluatePin(this.pinArray);
          }
        });
      });
    },
    openLock() {
      setTimeout(() => {
        window.hasMountedHome = true;
        this.$root.locked = false;
        this.$root.$data.showNavbar = true;
        this.pinArray = [];
        this.bindPinToDisplay();
      }, 300);
    },
    loginWithBiometrics() {
      if (webkit && webkit.messageHandlers) {
        webkit.messageHandlers.callback.postMessage(`faceId|auth`);
        window.faceIdAuthenticated = (x) => {
          if (x == "success") VueInstance.$data.locked = false;
          else if (x == "failure") ModernModals.alert("Couldn't Verify Identity!");
          else if (x == "error")
            ModernModals.alert("You may not have any faces or fingerprints registered");
          else if (x == "notSupported")
            ModernModals.alert("Your device doesn't support biometric signin.");
        };
      } else {
        ModernModals.alert("Your device doesn't support biometric signin yet.");
      }
    },
    bindPinToDisplay(pinStatus = "") {
      $$(".pin-circle").forEach((el, index) => {
        if (pinStatus === "success") {
          el.addClass("success");
        } else if (pinStatus === "error") {
          el.addClass("error");
        } else if (index > this.pinArray.length - 1) {
          el.removeClass("entered");
          el.removeClass("success");
          el.removeClass("error");
        } else {
          el.addClass("entered");
        }
      });

      if (pinStatus === "error") $(".confirmation-dots").addClass("error");
      else $(".confirmation-dots").removeClass("error");
    },
  },
};
</script>
